export default[
    {
        path: '/taxa/cadastro/:id',
        name: 'cadastra taxas', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/taxa/lista/:id',
        name: 'lista taxas', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/taxa/editar/:tomador/:id',
        name: 'editar taxas', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]